"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basename = basename;
exports.extname = extname;
function basename(path, extension) {
    return path.slice(path.lastIndexOf('/') + 1).replace(extension || '', '');
}
function extname(path) {
    const slashPos = path.lastIndexOf('/');
    const dotPos = path.lastIndexOf('.');
    if (slashPos < dotPos) {
        return path.slice(dotPos);
    }
    else {
        return '';
    }
}
